import React from "react";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-[#0A1E3D] via-[#112A55] to-[#0A1E3D] px-6 text-center text-white">
      {/* Código grande */}
      <h1 className="text-[6rem] font-extrabold tracking-tight sm:text-[8rem]">
        404
      </h1>

      {/* Mensaje */}
      <p className="mt-4 text-lg sm:text-xl text-neutral-200">
        ¡Ups! La página que buscas no existe o fue movida.
      </p>

      {/* CTA */}
      <div className="mt-8">
        <Link
          to="/"
          className="inline-flex items-center rounded-lg bg-white px-6 py-3 text-sm font-semibold text-[#0A1E3D] shadow-sm transition hover:bg-neutral-200"
        >
          Volver al inicio
        </Link>
      </div>
    </main>
  );
};

export default ErrorPage;
